import { signal, WritableSignal, Signal } from '@angular/core';
import { Ref } from '../providers/ref';

/**
 * Tipo que permite objetos O tipos primitivos
 */
export type StateType = Record<string, any> | boolean | number | string;

export abstract class BaseNotifier<T extends StateType> {
  protected _state: WritableSignal<T>;
  protected readonly ref: Ref;

  constructor(ref: Ref, initialState: T) {
    this.ref = ref;
    this._state = signal<T>(initialState as T);
    // Disparamos la construcción inicial del estado
    this.build();
  }

  get state(): Signal<T> {
    return this._state.asReadonly();
  }

  /**
   * Obtiene el valor actual del estado (para uso en notifiers derivados)
   */
  protected getStateValue(): T {
    return this._state();
  }

  /**
   * Actualiza el estado completamente
   */
  protected setState(newState: T): void {
    this._state.set(newState);
  }

  /**
   * Actualiza el estado basado en el valor anterior
   */
  protected updateState(updater: (prevState: T) => T): void {
    this._state.update(updater);
  }

  /**
   * Build method - Called automatically when provider is first created
   * Override this method to initialize state with dependencies
   *
   * Equivalent to Riverpod's build() method
   * Puede ser sync o async
   */
  build(): T | void | Promise<T | void> {
    // Override in subclasses to initialize state with dependencies
  }
}
